export const ja_forcreators = {
  main1: "収益化をこれまでよりもはるかに簡単に",
  sub1: "Ubiqには収益化のハードルが存在せず、最初の投稿から広告収入をbiqという独自トークンで受け取ることができます。",
  main2: "画像にこれまで以上の情報と、可能性を",
  sub2: "投稿するグラフィック上の文字情報を読み取るので、Ubiq Web版にてWeb検索流入を見込めたり、画像や文字の上にハイパーリンクを貼ったり、InstagramやPinterestで実現できなかった拡張性を実現します。",
}